import axios from "@/axios";

const getCheckPermissionsViewEdit = async ({
  formId,
  packageId,
  entityTypeId,
}) => {
  // const url = `screening-package/7fa96389-1b16-412c-9102-0a60f23e7c6e/form/82b3e62f-891f-47f4-8f98-7ad7a7e02765/entity/0eff00b1-dcb0-4be5-aafd-5f8b90bf83dd/access-groups`;

  const url = `screening-package/${packageId}/form/${formId}/entity/${entityTypeId}/access-groups`;
  // const url = `/screening-package/${packageId}/check/${checkId}/access-groups`;
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    console.warn(
      error.response.data.detail || "Failed to fetch check permissions"
    );
  }
};

const updateCheckPermissionsViewEdit = async ({
  formId,
  packageId,
  entityTypeId,
  data: payload,
}) => {
  const url = `screening-package/${packageId}/form/${formId}/access-groups`;
  try {
    payload.entity_type_id = entityTypeId;
    const { data } = await axios.put(url, payload);
    return data;
  } catch (error) {
    console.warn(
      error.response.data.detail || "Failed to update check permissions"
    );
  }
};

export { updateCheckPermissionsViewEdit, getCheckPermissionsViewEdit };
